/* TWRD (Black & White): size chips and sort control in the collection bar.

   Layer (a), "filter" mode: a Size filter exists on the storefront. The chips
   are links, and the theme's own AJAX renderer does the work, so the grid, the
   editorial tile and the verse references all come back from the server. The
   theme does not re-render the actions bar, so the chip markup is mirrored
   inside .js-active-filters, which it does re-render, and copied back.

   Layer (b), "client" mode: no Size filter yet. The chips are buttons, and the
   cards are hidden here, from data-twrd-sizes printed by product-card.liquid.
   The editorial tile is never hidden, and the counts follow the visible cards. */
(function () {
  'use strict';

  var ACTIVE = null;

  /* Eet filtersystem. Naar twrd-filter-drawer.js er paa siden ejer den baade
     skuffen og stoerrelses-pillerne, og denne fil roerer ikke kortene. */
  function engine() {
    return window.TwrdFilters || null;
  }

  function host(node) {
    return node.closest ? node.closest('dynamic-product-search') : null;
  }

  function queryOf(href) {
    var parts = String(href).split('?');
    return parts.length > 1 ? parts[1] : '';
  }

  function render(search, query) {
    if (search && typeof search.renderCollection === 'function') {
      search.renderCollection({ query: query });
      return true;
    }
    return false;
  }

  function chipBar(scope) {
    return (scope || document).querySelector('[data-twrd-chipbar] .twrd-bar__chips');
  }

  function isClientMode(scope) {
    var bar = chipBar(scope);
    return !!bar && bar.dataset.twrdChipMode === 'client';
  }

  function sizesOf(card) {
    var raw = card.getAttribute('data-twrd-sizes') || '';
    return raw
      .split(',')
      .map(function (value) {
        return value.trim().toUpperCase();
      })
      .filter(Boolean);
  }

  function setCounts(scope, visible, total) {
    var bar = chipBar(scope);
    var root = scope || document;
    var label = bar
      ? visible === 1
        ? bar.dataset.twrdCountOne
        : bar.dataset.twrdCountMany
      : '';
    var totalNode = root.querySelector('.js-results-total .collection-main__count-text');
    if (totalNode && label) totalNode.textContent = visible + ' ' + label;

    var showing = root.querySelector('.js-infinite-showing-count');
    var all = root.querySelector('.js-infinite-total-count');
    if (showing) showing.textContent = String(visible);
    if (all) all.textContent = String(total === null ? visible : total);
  }

  /* Layer (b): show only the cards that can be bought in the active size. */
  function applyClientFilter(scope) {
    var root = scope || document;
    var items = root.querySelectorAll('.twrd-cards > .o-layout__item');
    var visible = 0;
    var total = 0;

    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      var card = item.querySelector('product-card[data-twrd-sizes]');
      if (!card) continue; // the editorial tile and any message row stay put
      total += 1;
      var keep = !ACTIVE || sizesOf(card).indexOf(ACTIVE) !== -1;
      if (keep) {
        item.removeAttribute('data-twrd-hidden');
        visible += 1;
      } else {
        item.setAttribute('data-twrd-hidden', 'true');
      }
    }

    setCounts(root, visible, ACTIVE ? visible : total);
  }

  function paintChips(scope) {
    var bar = chipBar(scope);
    if (!bar) return;
    var chips = bar.querySelectorAll('[data-twrd-chip]');
    for (var i = 0; i < chips.length; i += 1) {
      var on = ACTIVE !== null && chips[i].dataset.twrdSize === ACTIVE;
      chips[i].classList.toggle('is-active', on);
      chips[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function sync(scope) {
    if (engine()) {
      // Motoren lytter selv paa loaded-eventet og laegger valgene paa igen.
      return;
    }
    if (isClientMode(scope)) {
      // Fixed chips: keep the row, re-apply the selection to the new grid.
      paintChips(scope);
      applyClientFilter(scope);
      return;
    }
    var source = scope.querySelector('[data-twrd-chips-src] .twrd-bar__chips');
    var bar = scope.querySelector('[data-twrd-chipbar]');
    if (source && bar) bar.innerHTML = source.outerHTML;
  }

  document.addEventListener('click', function (event) {
    var chip = event.target.closest ? event.target.closest('[data-twrd-chip]') : null;
    if (!chip) return;
    event.preventDefault();
    if (chip.getAttribute('aria-disabled') === 'true') return;

    var size = chip.dataset.twrdSize;
    if (size) {
      if (engine()) return; // twrd-filter-drawer.js haandterer pillen

      var scope = host(chip) || document;
      ACTIVE = ACTIVE === size.toUpperCase() ? null : size.toUpperCase();
      paintChips(scope);
      applyClientFilter(scope);
      return;
    }

    var href = chip.getAttribute('href');
    if (!href) return;
    if (!render(host(chip), queryOf(href))) window.location.assign(href);
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest ? event.target.closest('[data-twrd-sort]') : null;
    if (!select) return;
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', select.value);
    params.delete('page');
    var query = params.toString();
    if (!render(host(select), query)) {
      window.location.assign(window.location.pathname + '?' + query);
    }
  });

  function start() {
    var searches = document.querySelectorAll('dynamic-product-search');
    for (var i = 0; i < searches.length; i += 1) {
      searches[i].addEventListener('on:dynamic-product-search:loaded', function (event) {
        sync(event.currentTarget);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
